export const _imageSrcArray = [
  "1.png",
  "4.jpeg",
  "3.jpeg",
  "2.jpeg",

  "19.jpeg",
  "14.jpeg",
  "5.png",
  "10.jpeg",

  "13.jpeg",
  "9.jpeg",
  "12.jpeg",
  "15.jpeg",

  "6.png",
  "18.jpeg",
  "8.png",
  "17.jpeg",

  "11.jpeg",
  "7.jpeg",
  "16.jpeg",
  "23.png",

  "21.png",
  "22.png",
  "20.png",
  "24.png",

  "25.png",
  "26.png",
  "31.png",
  "32.png",

  "27.png",
  "28.png",
  "29.png",
  "30.png",
];
export const _path = `image/gallery`;
